function setCookie(c_name,value,exdays){var exdate=new Date();exdate.setDate(exdate.getDate() + exdays);var c_value=escape(value) + ((exdays==null) ? "" : "; expires="+exdate.toUTCString());document.cookie=c_name + "=" + c_value;}
function getCookie(c_name){var c_value = document.cookie;var c_start = c_value.indexOf(" " + c_name + "=");if (c_start == -1){c_start = c_value.indexOf(c_name + "=");}if (c_start == -1){c_value = null;}else{c_start = c_value.indexOf("=", c_start) + 1;var c_end = c_value.indexOf(";", c_start);if (c_end == -1){c_end = c_value.length;}c_value = unescape(c_value.substring(c_start,c_end));}return c_value;}
function delCookie(name){document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';}
jQuery(document).ready(function () {
  	/*let hostname = window.location.hostname;
  	if (hostname.replaceAll('.','') !== "scoshacom") { // remove all dots from your domain name here
      if (hostname.indexOf('scosha') != -1 || hostname.indexOf('shopifypreview') != -1 || hostname.indexOf('klarna') != -1) {
        console.log("scosha.com"); // this prevents redirect if using the permanent_domain
      } else {
        window.location.replace('https://scosha.com');
      }
    }*/
  	
  	//Checks if the cookie already exists
    if (!getCookie('scoshafirsttime')){
         //jQuery("#signup").addClass("active");
      	 //jQuery(".popUpOverlay").addClass("active");
         //Set's the cookie to true so there is a value and the code shouldn't run again.
         setCookie('scoshafirsttime',true);
    }
  
  	if(jQuery("#upcycle").length){
      if (!getCookie('scoshaupcyclefirsttime')) {
        jQuery("#helpUpcycle").addClass("active");
      	jQuery(".popUpOverlay").addClass("active");
        setCookie('scoshaupcyclefirsttime',true);
        
      }
  	}
  
  	jQuery(".closePopup").on("click", function() {
    	let parent = jQuery(this).parent();
      	if(parent.hasClass("signupInner")) {
          parent = parent.parent();
        }
      	parent.removeClass("active");
      	jQuery(".popUpOverlay").removeClass("active");
  	});
  
	//SLIDEOUT
	jQuery("#mobile-menu-wrap").addClass("visible");

	var slideoutWidth = jQuery("#mobile-menu-wrap").outerWidth();
	var slideout = new Slideout({
		'panel': document.getElementById('panel'),
		'menu': document.getElementById('mobile-menu-wrap'),
		'padding': slideoutWidth,
		'tolerance': 70,
		'side': 'left',
      	'touch': false
	});

	var fixed = document.querySelector('header');
	var menuLevel = 0;
	var lastScrollTop = 0;

	slideout
		.on('beforeopen', function () {
			this.panel.classList.add('panel-open');
			fixed.style.transform = 'translateY(' + document.documentElement.scrollTop + 'px)';
		})
		.on('open', function () {
			this.panel.addEventListener('click', close);
		})
		.on('beforeclose', function () {
			this.panel.classList.remove('panel-open');
			this.panel.removeEventListener('click', close);
		});
	slideout.on('close', function () {
		fixed.style.transform = 'translateY(0)';
	});
	
  	//Product Accordion Section
	jQuery("#productExtraDetails").accordion({
		icons: { "header": "ui-icon-plus", "activeHeader": "ui-icon-minus" },
		heightStyle: "content",
      	collapsible: true
	});
  
  	//Footer Accordion Section
  	jQuery(".customerService").accordion({
		icons: { "header": "ui-icon-plus", "activeHeader": "ui-icon-minus" },
		heightStyle: "content",
      	collapsible: true,
      	active: false
	});
  
  	jQuery(".moreMenu").accordion({
		icons: { "header": "ui-icon-plus", "activeHeader": "ui-icon-minus" },
		heightStyle: "content",
      	collapsible: true,
      	active: false
	});
  
  	//Announcements
  	jQuery("#topBar").slick({
    	dots: false,
      	arrows: false,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
      	autoplay: true,
  		autoplaySpeed: 3000,
    });

	//Header
	var scrollHeight = jQuery(document).scrollTop();
	if (scrollHeight >= 50) {
		//jQuery("#mainHeader").addClass("fadeIn");
	} else if (scrollHeight < 50) {
		//jQuery("#mainHeader").removeClass("fadeIn");
	}
	jQuery(document).scroll(function () {
		scrollHeight = jQuery(this).scrollTop();
		console.log(scrollHeight);
		if (scrollHeight >= 50) {
			//jQuery("#mainHeader").addClass("fadeIn");
		} else if (scrollHeight < 50) {
			//jQuery("#mainHeader").removeClass("fadeIn");
		}
	});

	// Toggle button
	document.querySelector('#mobileMenuButton a').addEventListener('click', function (event) {
		event.preventDefault();
		slideout.toggle();
	});

	document.querySelector('#close-mobile-button').addEventListener('click', function (event) {
		event.preventDefault();
		slideout.toggle();
		jQuery('#mobile-menu li ul').removeClass('expanded');
		jQuery('#mobile-menu-back').removeClass('active');
	});
  
	/*
	jQuery('#mobile-menu ul li.mobileParentItem a').bind('click', function (event) {
		event.preventDefault();
		jQuery('#mobile-menu li ul').removeClass('expanded');
		jQuery(this).parent().children('ul').addClass('expanded');
		menuLevel = 1;
		jQuery('#mobile-menu-back').addClass('active');
	});

	jQuery('#mobile-menu ul li.mobileParentItem ul li a').unbind('click');

	jQuery('#mobile-menu ul li.mobileParentItem ul li.mobileParentItem a').bind('click', function (event) {
		event.preventDefault();
		jQuery(this).parent().children('ul').addClass('expanded');
		menuLevel = 2;
	});

	jQuery('#mobile-menu ul li.mobileParentItem ul li.mobileParentItem ul li a').unbind('click');

	document.getElementById('mobile-menu-back').addEventListener('click', function (event) {
		event.preventDefault();
		if (menuLevel === 1) {
			jQuery('#mobile-menu li ul').removeClass('expanded');
			jQuery('#mobile-menu-back').removeClass('active');
		} else if (menuLevel === 2) {
			jQuery('#mobile-menu li ul li ul').removeClass('expanded');
		}
		menuLevel--;
	});
    */
  	let firstMobileOpen = true;
  
  	jQuery(".mobilePrimary").accordion({
		icons: { "header": "ui-icon-plus", "activeHeader": "ui-icon-minus" },
		heightStyle: "content",
      	collapsible: true,
      	active: false
	});

    /*jQuery(".mobilePrimary").accordion({
      activate: function(){ 
        if(jQuery(".mobilePrimary a#ui-id-7").hasClass("ui-state-active") && jQuery(".mobilePrimary a#ui-id-18").hasClass("ui-state-active") && firstMobileOpen) {
        	jQuery( ".mobilePrimary" ).accordion( "option", "active", false );	}
      	}
    });*/
  
  	jQuery(".mobileSecondary").accordion({
		icons: { "header": "ui-icon-plus", "activeHeader": "ui-icon-minus" },
		heightStyle: "content",
      	collapsible: true,
      	active: false
	});
  
  	/*jQuery(".mobileSecondary").accordion({
      activate: function(){ jQuery( ".mobileSecondary" ).accordion( "option", "active", false );	}
    });*/
  
  	jQuery(".mobilePrimary").accordion("option", "active", 0);
  
  	jQuery(".mobileSecondary.Ladies").accordion("option", "active", 0);
  
  	jQuery(".mobileSecondary.Gents").accordion("option", "active", 0);
  
	jQuery(".mobilePrimary a#ui-id-7").removeClass().addClass("ui-accordion-header ui-corner-top ui-state-default ui-accordion-icons ui-accordion-header-active ui-state-active");  
  	jQuery(".mobilePrimary a#ui-id-7 span").removeClass().addClass("ui-accordion-header-icon ui-icon ui-icon-minus");
  	/*jQuery(".mobilePrimary a#ui-id-18").removeClass().addClass("ui-accordion-header ui-corner-top ui-state-default ui-accordion-icons ui-accordion-header-active ui-state-active");
  	jQuery(".mobilePrimary a#ui-id-18 span").removeClass().addClass("ui-accordion-header-icon ui-icon ui-icon-minus");*/
  
  	//jQuery(".mobileTertiary.Core").css("display", "block");
  	jQuery(".mobileSecondary.Gents").css("display", "block");
    
  
  	jQuery(".mobileSecondary.Conscience").accordion("destroy");
  	jQuery(".mobileSecondary.SUMMER.SALE").accordion("destroy");
  
  
  	jQuery(".mobilePrimary .ui-accordion-header").on("click", function() {
      if(firstMobileOpen) {
        firstMobileOpen = false;
        jQuery(".mobilePrimary a#ui-id-7").removeClass().addClass("ui-accordion-header ui-corner-top ui-accordion-header-collapsed ui-corner-all ui-state-default ui-accordion-icons");  
        jQuery(".mobilePrimary a#ui-id-7 span").removeClass().addClass("ui-accordion-header-icon ui-icon ui-icon-plus");
        /*jQuery(".mobilePrimary a#ui-id-18").removeClass().addClass("ui-accordion-header ui-corner-top ui-accordion-header-collapsed ui-corner-all ui-state-default ui-accordion-icons");
        jQuery(".mobilePrimary a#ui-id-18 span").removeClass().addClass("ui-accordion-header-icon ui-icon ui-icon-plus");*/

        jQuery(".mobileTertiary.Fine").css("display", "none");
        jQuery(".mobileSecondary.Gents").css("display", "none");
        
      }
    });
  
  	
  	jQuery(".mobileSingleItem a span").remove();
  	jQuery(".mobileSingleItem a").on("click", function(event){
      event.preventDefault();
      window.location.href = jQuery(this).attr('href');
    });
  
  	jQuery(".mobileSecondary .vintage.jewelry span").remove();
  	jQuery(".mobileSecondary .vintage.jewelry a").on("click", function(event){
      event.preventDefault();
      window.location.href = jQuery(this).attr('href');
    });
  	

	//SUBMENU
	var submenuFade;
	var tertiaryMenuHTML = jQuery('#tertiaryMenuItems').html();

	jQuery("#mainNav ul li").hover(
		function () {
			clearTimeout(submenuFade);
			if (jQuery(this).hasClass("menu-item-has-children")) {
				console.log('mainNav open');
              	if(jQuery(this).hasClass("columnMenu")) {
                   jQuery("#subMenu").addClass("column");
            	} else {
                  jQuery("#subMenu").removeClass("column");
                }
				var subMenuHTML = jQuery(this).children(".subMenu").html();
				var itemPos = jQuery(this).position().left;
				itemPos = "translateX(" + itemPos + "px)";
				jQuery("#subMenu").removeClass("columnMenu");
				if (jQuery(this).children(".subMenu2020").hasClass('columnMenu')) {
					jQuery("#subMenu").addClass('columnMenu');
				}
				jQuery("#subMenu").addClass("active");
				if (jQuery(this).hasClass('columnMenu')) {
					jQuery("#subMenu").css("transform", "translateX(0px)");
				} else {
					jQuery("#subMenu").css("transform", itemPos);
				}
				jQuery("#subMenuItems ul").html(subMenuHTML);
				jQuery('#tertiaryMenuItems').html(tertiaryMenuHTML);
				jQuery("#subMenuItems").addClass("active");
			} else {
				jQuery("#subMenu").removeClass("active");
			}
		},
		function () {
			if (jQuery(this).hasClass("menu-item-has-children")) {
              	clearTimeout(submenuFade);
				submenuFade = setTimeout(function () {
					jQuery("#subMenu").removeClass("active");
					jQuery("#subMenu").removeClass("columnMenu");
					console.log("mainNav close");
				}, 1000);
			}
		});

	jQuery("#subMenu").on({
		mouseenter: function () {
			clearTimeout(submenuFade);
			jQuery("#subMenu").addClass("active");
			console.log("submenu entered");
		},
		mouseleave: function () {
          	clearTimeout(submenuFade);
			submenuFade = setTimeout(function () {
				jQuery("#subMenu").removeClass("active");
              	jQuery("#subMenu li").removeClass("active");
				jQuery("#subMenu").removeClass("columnMenu");
				console.log("submenu close");
			}, 1000)
		}
	});

	jQuery("#tertiaryMenuItems").on({
		mouseenter: function () {
			clearTimeout(submenuFade);
			jQuery("#subMenu").addClass("active");
			console.log("teriary entered");
		},
		mouseleave: function () {
          	jQuery('#subMenu li').removeClass('active');
          	clearTimeout(submenuFade);
			submenuFade = setTimeout(function () {
				jQuery("#subMenu").removeClass("active");
				jQuery("#subMenu").removeClass("columnMenu");
				console.log("tertiary close");
			}, 1000);
		}
	});

	jQuery("#tertiaryMenuItems li").mouseenter(function () {
		clearTimeout(submenuFade);
		jQuery("#subMenu").addClass("active");
		console.log("teriary entered");
	});

	jQuery(document).on({
		mouseenter: function () {
			clearTimeout(submenuFade);
			console.log('subMenuItems entered');
			jQuery("#subMenu").addClass("active");
          	jQuery("#subMenu li").removeClass("active");
          	jQuery(this).addClass('active');
			var innerItems = jQuery(this).children('.subMenuPanel').html();
          	console.log("Inner Items:" + innerItems);
          	if(innerItems) {
				jQuery('#tertiaryMenuItems').html(innerItems);
            } else {
              jQuery('#tertiaryMenuItems').html('');
            }
		},
		mouseleave: function () {
          	clearTimeout(submenuFade);
			submenuFade = setTimeout(function () {
				jQuery("#subMenu").removeClass("active");
				jQuery("#subMenu").removeClass("columnMenu");
              	jQuery("#subMenu li").removeClass("active");
				jQuery('#tertiaryMenuItems').html(tertiaryMenuHTML);
				console.log("subMenuItems close");
			}, 1000);
		}
	}, '#subMenuItems ul li');


	//SEARCH 
	jQuery("#shopActions a.searchToggle").bind("click", function (event) {
      if(jQuery("#shopActions .search-input").val()) {
      } else {
      	event.preventDefault();
		jQuery("#mainHeader #shopActions ul li .searchToggle form").addClass('active');
		if (jQuery("#mainHeader #shopActions ul li .searchToggle form").hasClass('active')) {
			setTimeout(function () { jQuery('#mainHeader #shopActions ul li .searchToggle form .search-input').focus() }, 5);
		}
      }
	});
  
  jQuery("#shopActions .search-input").on("keyup", function(event){
    if (event.keyCode === 13) {
      jQuery("#shopActions .search-submit").click();
    }
  });

	jQuery(document).on('click', function (event) {
		var targetEl = jQuery(event.target);
		console.log(targetEl);
		if (!targetEl.parent().children("form").length && jQuery("#mainHeader #shopActions ul li .searchToggle form").hasClass('active')) {
			jQuery("#mainHeader #shopActions ul li .searchToggle form").removeClass('active');
		}
	});

	//SHOP ACTION PANELS 
	jQuery("#shopActions a").bind("click", function (event) {
		if (jQuery(this).hasClass('bagToggle')) {
			event.preventDefault();
			jQuery("#heartPanel").removeClass('active');
			jQuery("#accountPanel").removeClass('active');
			jQuery("#bagPanel").addClass('active');
		}
	});

	jQuery(".closePanel").each(function () {
		jQuery(this).bind("click", function (event) {
			event.preventDefault();
			jQuery(this).parent().parent().removeClass("active");
		});
	});
  
  	//CART PANEL MANUAL REFRESH
  	jQuery.getJSON('/cart.js', function(cart) {
      console.log(cart);
      var cartSubTotal = cart.items_subtotal_price / 100;
      jQuery('.bagToggle sup').html(cart.item_count);
      //console.log(cart.items);
      if(cart.item_count == 0) {
		jQuery('.panelInfo form.cart').fadeOut('fast').remove();
        jQuery('.noResults').remove();
		var noResults = '<div class="noResults"><p>You have not added any items to your bag yet.</p></div>';
		jQuery('.shopActionsPanel .panelInfo').append(noResults);
      } else {
        if(jQuery('.mini-cart-info').length) {
          jQuery('.mini-cart-info table tbody').html('');
        } else {
          jQuery('.noResults').remove();
          var cartResults = '<form action="/cart" method="post" novalidate="" class="cart" id="mini-cart"><div class="mini-cart-info"><table><tbody></tbody></table></div>';
          cartResults += '<div class="mini-cart-total"><table><tbody><tr><td><b>Subtotal :</b></td><td class="miniSubTotal">$'+ cartSubTotal + '</td></tr></tbody></table></div>';
          cartResults += '<div class="viewCart"><a class="checkoutlink" href="/cart">Check Out</a></div></form>';
          jQuery('.shopActionsPanel .panelInfo').append(cartResults);
        }
        for(var key in cart.items) {
          var cartItem = cart.items[key];
          var lineItem = parseInt(key) + 1;
          var engraving = (cartItem.product_type === "Engraving") ? true : false;
          var itemRow = "";
          if(engraving == true) {
            itemRow = '<tr class="engraving"><td colspan="5"><p class="withEngraving">+</p></td></tr><tr class="engraving">';
          } else {
            itemRow = "<tr>";
          }
          if((cartItem.product_type == "Totem" || cartItem.product_type == "Totem Belt" || cartItem.product_type == "Signature Charm Bracelet") && cartItem.product_title.indexOf('Bracelet') != -1) {
            let cartItemImg = cartItem.image.replace("products/", "products/THUMB-");
            if(cartItem.product_type == "Signature Charm Bracelet") {
              cartItemImg = cartItemImg.replace(".jpg", ".png");
            }
            itemRow += "<td class='image'><img src='" + cartItemImg +"' class='totemCartImage' /></td>";
          } else if(engraving == false) {
            itemRow += "<td class='image'><img src='" + cartItem.image +"' /></td>";
          }
          if(engraving == true) {
            itemRow += '<td class="name" colspan="2">';
          } else {
            itemRow += '<td class="name">';
          }
          if(this.product_type != "Totem" || this.product_type != "Totem Belt" || this.product_type != "Signature Charm Bracelet") {
            itemRow += '<a href="'+ cartItem.url +'">';
          }
          itemRow += cartItem.product_title;
          if(this.product_type != "Totem" || this.product_type != "Totem Belt" || this.product_type != "Signature Charm Bracelet") {
            itemRow += '</a>';
          }
          itemRow += '<div>';
          for (var index in cartItem.options_with_values){
            var option = cartItem.options_with_values[index];
            if(option.value != "Default Title" && option.value != "Default") {
              if( option.value == "None" || option.value == "Hand Stamping" || option.value == "Engraving in Script" || option.value == "Engraving in Block Letters") {
                itemRow += "<small>Personalization: " + option.value + "</small><br/>";
              } else if( option.value =="Gold with Diamond" || option.value == "Sterling Silver") {
                itemRow += "<small>Closure Color: " + option.value + "</small><br/>";
              } else {
                itemRow += "<small>" + option.name + ": " + option.value + "</small><br/>";
              }
            }
          }
          var obj = cartItem.properties;
          if(obj !== null){
            var extraOptions = Object.keys(obj).map(function (key) { 
              if(obj[key]!="" && key != "Bracelet Order" && key != "Bracelet Number" && key != "Engraving for"){
                return("<small>" + key + ": <span class='cartPersonalization'>" +obj[key] + "</span></small><br/>");
              } 
            });
            extraOptions = extraOptions.toString();
            extraOptions = extraOptions.replace(",", "");
            itemRow += extraOptions;
          }
          itemRow += '</div></td>';             
          itemRow += '<td class="quantity">x&nbsp;' + cartItem.quantity + '</td>';
          var price = cartItem.price / 100;
          itemRow += '<td class="total">$'+ price +'</td>';
          itemRow += '<td class="remove"><a href="#" data-id="'+ lineItem +'" class="removeCartItem"><i class="fal fa-times"></i></a></td>';
          itemRow += '</tr>';
          //console.log(itemRow);
          jQuery('.mini-cart-info table tbody').append(itemRow);
        }
    }
    jQuery('#cartCount').html(cart.item_count);
    jQuery('.miniSubTotal').html("$" + cartSubTotal);
    });

	//CART PANEL ACTIONS {
	jQuery(document).on('click', ".removeCartItem", function (event) {
		event.preventDefault();
		var prodID = jQuery(this).data('id');
		var cartItem = { 'line': prodID, 'quantity': 0 };
		jQuery.post('/cart/change.js', cartItem, function () {
			jQuery.getJSON('/cart.js', function (cart) {
				var cartCount = cart.item_count;
				jQuery('.bagToggle sup').html(cartCount);
				if (cartCount == 0) {
					jQuery('.panelInfo form.cart').fadeOut('fast').remove();
                  	jQuery('.mini-cart-total').fadeOut('fast').remove();
                  	jQuery('.viewCart').fadeOut('fast').remove();
					var noResults = '<div class="noResults"><p>You have not added any items to your bag yet.</p></div>';
					jQuery('.shopActionsPanel .panelInfo').append(noResults);
                  	jQuery('.cartCount').html(cart.item_count);
				} else {
					var cartSubTotal = cart.items_subtotal_price / 100;
					if (jQuery('.mini-cart-info').length) {
						jQuery('.mini-cart-info table tbody').html('');
					} else {
						jQuery('.noResults').remove();
                        var cartResults = '<form action="/cart" method="post" novalidate="" class="cart" id="mini-cart"><div class="mini-cart-info"><table><tbody></tbody></table></div>';
                        cartResults += '<div class="mini-cart-total"><table><tbody><tr><td><b>Subtotal :</b></td><td class="miniSubTotal">$'+ cartSubTotal + '</td></tr></tbody></table></div>';
                        cartResults += '<div class="viewCart"><a class="checkoutlink" href="/cart">Check Out</a></div></form>';
                        jQuery('.shopActionsPanel .panelInfo').append(cartResults);
					}
					for (var key in cart.items) {
						var cartItem = cart.items[key];
                        var lineItem = parseInt(key) + 1;
                        var engraving = (cartItem.product_type === "Engraving") ? true : false;
                        var itemRow = "";
                        if(engraving == true) {
                          itemRow = '<tr class="engraving"><td colspan="5"><p class="withEngraving">+</p></td></tr><tr class="engraving">';
                        } else {
                          itemRow = "<tr>";
                        }
                        if((cartItem.product_type == "Totem" || cartItem.product_type == "Totem Belt" || cartItem.product_type == "Signature Charm Bracelet") && cartItem.product_title.indexOf('Bracelet') != -1) {
                          let cartItemImg = cartItem.image.replace("products/", "products/THUMB-");
                          if(cartItem.product_type == "Signature Charm Bracelet") {
                            cartItemImg = cartItemImg.replace(".jpg", ".png");
                          }
                          itemRow += "<td class='image'><img src='" + cartItemImg +"' class='totemCartImage' /></td>";
                        } else if(engraving == false) {
                          itemRow += "<td class='image'><img src='" + cartItem.image +"' /></td>";
                        }
                        if(engraving == true) {
                          itemRow += '<td class="name" colspan="2">';
                        } else {
                          itemRow += '<td class="name">';
                        }
                        if(this.product_type != "Totem" || this.product_type != "Totem Belt" || this.product_type != "Signature Charm Bracelet") {
                          itemRow += '<a href="'+ cartItem.url +'">';
                        }
                        itemRow += cartItem.product_title;
                        if(this.product_type != "Totem" || this.product_type != "Totem Belt" || this.product_type != "Signature Charm Bracelet") {
                          itemRow += '</a>';
                        }
                        itemRow += '<div>';
                        for (var index in cartItem.options_with_values){
                          var option = cartItem.options_with_values[index];
                          if(option.value != "Default Title" && option.value != "Default") {
                            if( option.value == "None" || option.value == "Hand Stamping" || option.value == "Engraving in Script" || option.value == "Engraving in Block Letters") {
                              itemRow += "<small>Personalization: " + option.value + "</small><br/>";
                            } else if( option.value =="Gold with Diamond" || option.value == "Sterling Silver") {
                              itemRow += "<small>Closure Color: " + option.value + "</small><br/>";
                            } else {
                              itemRow += "<small>" + option.name + ": " + option.value + "</small><br/>";
                            }
                          }
                        }
                        var obj = cartItem.properties;
                        if(obj !== null){
                          var extraOptions = Object.keys(obj).map(function (key) { 
                            if(obj[key]!="" && key != "Bracelet Order" && key != "Bracelet Number" && key != "Engraving for"){
                              return("<small>" + key + ": <span class='cartPersonalization'>" +obj[key] + "</span></small><br/>");
                            } 
                          });
                          extraOptions = extraOptions.toString();
                          extraOptions = extraOptions.replace(",", "");
                          itemRow += extraOptions;
                        }
                        itemRow += '</div></td>';             
                        itemRow += '<td class="quantity">x&nbsp;' + cartItem.quantity + '</td>';
                        var price = cartItem.price / 100;
                        itemRow += '<td class="total">$'+ price +'</td>';
                        itemRow += '<td class="remove"><a href="#" data-id="'+ lineItem +'" class="removeCartItem"><i class="fal fa-times"></i></a></td>';
                        itemRow += '</tr>';
                        console.log(itemRow);
                        jQuery('.mini-cart-info table tbody').append(itemRow);
					}
					jQuery('.cartCount').html(cart.item_count);
					jQuery('.miniSubTotal').html("$" + cartSubTotal);
				}
			});
		});
	});

	//PASSWORD RECOVERY
	function showRecoverPasswordForm() {
		document.getElementById('RecoverPasswordForm').style.display = 'block';
		document.getElementById('CustomerLoginForm').style.display = 'none';
	}

	function hideRecoverPasswordForm() {
		document.getElementById('RecoverPasswordForm').style.display = 'none';
		document.getElementById('CustomerLoginForm').style.display = 'block';
	}
  
  //INSTAFEED
  if(jQuery("#instafeed").length){
  	var userFeed = new Instafeed({
          get: 'user',
          userId: '24830690',
          accessToken: 'IGQVJVNUhNNDVyYjhDdF9HZAXZATbVk3RTd6RUl6bmlKU3c1czhmUWxfcjVmc19xQmlZAMUtnUW9LWEJBd18wNXlkbFFrU3JDOHg3THdTUFY4bHVSUUZAmdTRjRHVSb25WWUNRckllVW9DV0xiTXVzemFzdQZDZD',
          limit:500,
          resolution: "standard_resolution",
          after: function(){
          	$('#instafeed').slick({
    			infinite: true,
              	adaptiveHeight: true,
  				slidesToShow: 5
  			});
        	}
    	});
    	userFeed.run();
  	}
  
  	//POP-UPS
  	jQuery(".closePop-up").on('click', function(){
      jQuery(this).parent().removeClass('active');
  	});

	//PRODUCT GALLERY
	jQuery('#mainImg').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		nextArrow: '<button type="button" class="slick-next"><i class="fas fa-caret-right"></i></button>',
		prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-caret-left"></i></button>',
		fade: true,
		asNavFor: '#productGallery',
		centerMode: true,
      	responsive: [
          {
            breakpoint: 1100,
            settings: {
              arrows: true,
              nextArrow: '<button type="button" class="slick-next"><i class="fal fa-angle-right"></i></button>',
              prevArrow: '<button type="button" class="slick-prev"><i class="fal fa-angle-left"></i></button>',
              fade: false
            }
          }
        ]
	});

	var galleryImage = jQuery("#productGallery img").length;
  	galleryImage = galleryImage + 1;
	jQuery('#productGallery').slick({
		slidesToShow: galleryImage,
		slidesToScroll: 1,
		asNavFor: '#mainImg',
		dots: false,
		centerMode: true,
		focusOnSelect: true,
		vertical: true,
		arrows: false
	});

	jQuery(window).on('resize', function () {
		jQuery('#productGallery').slick({
			slidesToShow: galleryImage,
			slidesToScroll: 1,
			asNavFor: '#mainImg',
			dots: false,
			centerMode: true,
			focusOnSelect: true,
			vertical: true,
			arrows: false
		});

		jQuery('#mainImg').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			asNavFor: '#productGallery',
			centerMode: true,
			responsive: [
				{
					breakpoint: 1100,
					settings: {
						arrows: true,
						nextArrow: '<button type="button" class="slick-next"><i class="fal fa-angle-right"></i></button>',
						prevArrow: '<button type="button" class="slick-prev"><i class="fal fa-angle-left"></i></button>',
                      	fade: false
					}
				}
			]
		});
	});
  
  	// Sorting
    jQuery("#sortMenu .sorter").on("click", function(event){
      event.preventDefault();
      if(jQuery(this).data('sort') == 'highest') {
      	$('#collectionProducts').sortAsc();
      } else if(jQuery(this).data('sort') == 'lowest') {
        $('#collectionProducts').sortDec();
      }
    });
});

//Sort Helper Methods
$.fn.sortDec = function sortDec() {
    $("> article", this[0]).sort(dec_sort).appendTo(this[0]);
    function dec_sort(a, b){ return ($(b).data("price")) < ($(a).data("price")) ? 1 : -1; }
}
  
$.fn.sortAsc =  function sortAsc () {
    $("> article", this[0]).sort(dec_sort).appendTo(this[0]);
    function dec_sort(a, b){ return ($(b).data("price")) > ($(a).data("price")) ? 1 : -1; }
}

$(document).on('cart.requestStarted', function(event, cart) {
  jQuery.getJSON('/cart.js', function(cart) {
      console.log(cart);
      var cartSubTotal = cart.items_subtotal_price / 100;
      jQuery('.bagToggle sup').html(cart.item_count);
      //console.log(cart.items);
      if(cart.item_count == 0) {
		jQuery('.panelInfo form.cart').fadeOut('fast').remove();
        jQuery('.noResults').remove();
		var noResults = '<div class="noResults"><p>You have not added any items to your bag yet.</p></div>';
		jQuery('.shopActionsPanel .panelInfo').append(noResults);
      } else {
        if(jQuery('.mini-cart-info').length) {
          jQuery('.mini-cart-info table tbody').html('');
        } else {
          jQuery('.noResults').remove();
          var cartResults = '<form action="/cart" method="post" novalidate="" class="cart" id="mini-cart"><div class="mini-cart-info"><table><tbody></tbody></table></div>';
          cartResults += '<div class="mini-cart-total"><table><tbody><tr><td><b>Subtotal :</b></td><td class="miniSubTotal">$'+ cartSubTotal + '</td></tr></tbody></table></div>';
          cartResults += '<div class="viewCart"><a class="checkoutlink" href="/cart">Check Out</a></div></form>';
          jQuery('.shopActionsPanel .panelInfo').append(cartResults);
        }
        for(var key in cart.items) {
          var cartItem = cart.items[key];
          var lineItem = parseInt(key) + 1;
          var engraving = (cartItem.product_type === "Engraving") ? true : false;
          var itemRow = "";
          if(engraving == true) {
            itemRow = '<tr class="engraving"><td colspan="5"><p class="withEngraving">+</p></td></tr><tr class="engraving">';
          } else {
            itemRow = "<tr>";
          }
          if((cartItem.product_type == "Totem" || cartItem.product_type == "Totem Belt" || cartItem.product_type == "Signature Charm Bracelet") && cartItem.product_title.indexOf('Bracelet') != -1) {
            let cartItemImg = cartItem.image.replace("products/", "products/THUMB-");
            if(cartItem.product_type == "Signature Charm Bracelet") {
              cartItemImg = cartItemImg.replace(".jpg", ".png");
            }
            itemRow += "<td class='image'><img src='" + cartItemImg +"' class='totemCartImage' /></td>";
          } else if(engraving == false) {
            itemRow += "<td class='image'><img src='" + cartItem.image +"' /></td>";
          }
          if(engraving == true) {
            itemRow += '<td class="name" colspan="2">';
          } else {
            itemRow += '<td class="name">';
          }
          if(this.product_type != "Totem" || this.product_type != "Totem Belt" || this.product_type != "Signature Charm Bracelet") {
            itemRow += '<a href="'+ cartItem.url +'">';
          }
          itemRow += cartItem.product_title;
          if(this.product_type != "Totem" || this.product_type != "Totem Belt" || this.product_type != "Signature Charm Bracelet") {
            itemRow += '</a>';
          }
          itemRow += '<div>';
          for (var index in cartItem.options_with_values){
            var option = cartItem.options_with_values[index];
            if(option.value != "Default Title" && option.value != "Default") {
              if( option.value == "None" || option.value == "Hand Stamping" || option.value == "Engraving in Script" || option.value == "Engraving in Block Letters") {
                itemRow += "<small>Personalization: " + option.value + "</small><br/>";
              } else if( option.value =="Gold with Diamond" || option.value == "Sterling Silver") {
                itemRow += "<small>Closure Color: " + option.value + "</small><br/>";
              } else {
                itemRow += "<small>" + option.name + ": " + option.value + "</small><br/>";
              }
            }
          }
          var obj = cartItem.properties;
          if(obj !== null){
            var extraOptions = Object.keys(obj).map(function (key) { 
              if(obj[key]!="" && key != "Bracelet Order" && key != "Bracelet Number" && key != "Engraving for"){
                return("<small>" + key + ": <span class='cartPersonalization'>" +obj[key] + "</span></small><br/>");
              } 
            });
            extraOptions = extraOptions.toString();
            extraOptions = extraOptions.replace(",", "");
            itemRow += extraOptions;
          }
          itemRow += '</div></td>';             
          itemRow += '<td class="quantity">x&nbsp;' + cartItem.quantity + '</td>';
          var price = cartItem.price / 100;
          itemRow += '<td class="total">$'+ price +'</td>';
          itemRow += '<td class="remove"><a href="#" data-id="'+ lineItem +'" class="removeCartItem"><i class="fal fa-times"></i></a></td>';
          itemRow += '</tr>';
          //console.log(itemRow);
          jQuery('.mini-cart-info table tbody').append(itemRow);
        }
    }
    jQuery('#cartCount').html(cart.item_count);
    jQuery('.miniSubTotal').html("$" + cartSubTotal);
    });
  	jQuery("#bagPanel").addClass('active');
});